<app-kyc-accordion
  accordionKey="bankDetails"
  accordionTitle="Bank Details"
  [isKycComplete]="isKycComplete"
>
  <div *ngIf="!bankDetails?.length">
    <p>No bank details</p>
  </div>
  @for (bankDetail of bankDetails; track bankDetail.id; let i = $index) {
    <div class="mb-8 rounded-md border p-4">
      @if (bankDetails.length > 1) {
        <h3 class="mb-4 text-lg font-semibold">Bank Account {{ i + 1 }}</h3>
      }
      <div
        *ngIf="bankDetails?.length"
        class="grid grid-cols-1 gap-y-5 md:grid-cols-4"
      >
          <ul class="text-mango-darkBlack">
            <li class="text-base font-medium">Account Name</li>
            <li class="text-sm font-light">
              {{ (bankDetail.bank_account_name | titlecase) || '—' }}
            </li>
          </ul>
          <ul class="text-mango-darkBlack">
            <li class="text-base font-medium">Account Number</li>
            <li class="text-sm font-light">
              {{ bankDetail.bank_account_number || '—' }}
            </li>
          </ul>
          <ul class="text-mango-darkBlack">
            <li class="text-base font-medium">Bank Name</li>
            <li class="text-sm font-light">
              {{
                (bankDetail.region === 'local'
                  ? getBankName(bankDetail.bank_code)
                  : bankDetail.bank_name) || '—'
              }}
            </li>
          </ul>
          <ul class="text-mango-darkBlack">
            <li class="text-base font-medium">Bank Branch</li>
            <li class="text-sm font-light">
              {{ (bankDetail.bank_branch | titlecase) || '—' }}
            </li>
          </ul>
          <ul class="text-mango-darkBlack">
            <li class="text-base font-medium">Currency</li>
            <li class="text-sm font-light">
              {{ (bankDetail.currency | uppercase) || '—' }}
            </li>
          </ul>
    
      </div>
    </div>
  }
</app-kyc-accordion>
